import { Col, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ReactComponent as DocsCurrencyIcon } from '../../../../../assets/icons/docs-currency.svg';
import { ReactComponent as DocsListIcon } from '../../../../../assets/icons/docs-list.svg';
import { ReactComponent as FilesIcon } from '../../../../../assets/icons/files-records.svg';
import { ReactComponent as NotesIcon } from '../../../../../assets/icons/notes.svg';
import { ReactComponent as SearchIcon } from '../../../../../assets/icons/search-icon.svg';
import { ReactComponent as ShipmentIcon } from '../../../../../assets/icons/shipment-file.svg';
import { ReactComponent as TruckIcon } from '../../../../../assets/icons/truck.svg';
import useShipmentRoutingSettings from '../../../../../redux/hooks/useShipmentRoutingSettings';
import { routeFileSelector } from '../../../../../utilz/i18n';
import SvgConverter from '../../../../components/Common/SvgConverter';
import CollapsiblePanel from '../../../../components/Tabs/CollapsiblePanel';
import AdditionalDetails from './Tabs/AdditionalDetails/AdditionalDetails';
import TMSDocumentDetails from './Tabs/DocumentDetails/TMSDocumentDetails';
import TMSNotesDetails from './Tabs/NotesDetails/TMSNotesDetails';
import TMSProductDetails from './Tabs/ProductDetails/TMSProductDetails';
import RateDetails from './Tabs/RateDetails/RateDetails';
import TMSQuoteDetailsForm from './Tabs/TMSQuoteDetailsForm';
import TMSTransportationDetails from './Tabs/TransportationDetails/TMSTransportationDetails';
import TransportationProviderSearchForm from './Tabs/TransportationProviderSearchForm';

const TMSCreateGetQuoteTabs = ({ activeKey, setActiveKey, rateShopList, selectedRateIndex, setSelectedRateIndex }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const handleTabClick = (keys) => {
    setActiveKey(keys);
  };
  const havingAccessForMenu = useShipmentRoutingSettings('isMenuVisible');

  const GenerateTitle = ({ title, Icon, size = 25 }) => {
    return (
      <Row gutter={10} align="middle">
        <Col className="lh-0">
          <SvgConverter width={size} height={size} Icon={Icon} />
        </Col>
        <Col className="lh-0">
          {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
          <label className="lh-0 text-dark cursor-pointer">{title}</label>
        </Col>
      </Row>
    );
  };

  return (
    <CollapsiblePanel
      forceRender
      handleTabClick={handleTabClick}
      activeKey={activeKey}
      tabs={[
        {
          content: <TMSQuoteDetailsForm />,
          header: <GenerateTitle title={t('translation:getQuote.titles.quoteDetails')} Icon={ShipmentIcon} size={25} />,
        },
        {
          content: <TMSTransportationDetails />,
          header: (
            <GenerateTitle title={t('translation:getQuote.titles.transportationDetails')} Icon={TruckIcon} size={25} />
          ),
        },
        {
          content: <TMSProductDetails />,
          header: (
            <GenerateTitle title={t('translation:default.fields.productDetails')} Icon={DocsListIcon} size={25} />
          ),
        },
        {
          content: <TransportationProviderSearchForm />,
          header: (
            <GenerateTitle
              title={t('translation:default.fields.transportationProviderSearch')}
              Icon={SearchIcon}
              size={25}
            />
          ),
        },
        ...(havingAccessForMenu
          ? [
              {
                content: <AdditionalDetails />,
                header: (
                  <GenerateTitle
                    title={t('translation:getQuote.titles.additionalServices')}
                    Icon={DocsCurrencyIcon}
                    size={25}
                  />
                ),
              },
            ]
          : []),
        {
          content: (
            <RateDetails
              rateShopList={rateShopList}
              selectedRateIndex={selectedRateIndex}
              setSelectedRateIndex={setSelectedRateIndex}
            />
          ),
          header: <GenerateTitle title={t('translation:getQuote.titles.rateShopResults')} Icon={NotesIcon} size={25} />,
          hidePadding: true,
        },
        {
          content: <TMSNotesDetails />,
          header: <GenerateTitle title={t('translation:getQuote.titles.quoteNotes')} Icon={NotesIcon} size={25} />,
        },
        {
          content: <TMSDocumentDetails />,
          header: <GenerateTitle title={t('translation:default.documentManager.title')} Icon={FilesIcon} size={25} />,
        },
      ]}
    />
  );
};

export default TMSCreateGetQuoteTabs;
